/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'warehouse': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M896 651.636a34.91 34.91 0 0034.91-34.909v-477.09a46.545 46.545 0 00-46.546-46.546H744.727V46.545A46.545 46.545 0 00698.182 0H325.818a46.545 46.545 0 00-46.545 46.545v46.546H139.636a46.545 46.545 0 00-46.545 46.545v837.819A46.545 46.545 0 00139.636 1024h744.728a46.545 46.545 0 0046.545-46.545V826.182a34.91 34.91 0 00-69.818 0v128H162.909V162.909h116.364v46.546A46.545 46.545 0 00325.818 256h372.364a46.545 46.545 0 0046.545-46.545v-46.546h116.364v453.818A34.91 34.91 0 00896 651.637zM674.91 186.182H349.09V69.818h325.82zM302.544 802.909a34.91 34.91 0 0034.91 34.91h349.09a34.91 34.91 0 000-69.819h-349.09a34.91 34.91 0 00-34.91 34.91zM512 325.82a34.91 34.91 0 00-34.91 34.908v221.091l-72.145-72.145a34.91 34.91 0 00-49.338 49.338l139.637 139.636a23.273 23.273 0 0032.814 0l139.637-139.636a34.91 34.91 0 10-49.339-49.338l-71.447 72.145v-221.09A34.91 34.91 0 00512 325.817z"/>'
  }
})
